import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_EMITENTES = "getEmitentes";
export const GET_EMITENTES_LISTA = "getEmitentesLista";
export const GET_EMITENTE = "getEmitente";
export const UPDATE_EMITENTE = "updateEmitente";
export const GET_CATEGORIAS_EMITENTE_LISTA = "getCategoriasEmitenteLista";
export const GET_CEP = "getCEP";
export const GET_CIDADES = "getCidades";
export const GET_CNPJ_CAPTCHA = "getCNPJCaptcha";
export const GET_CNPJ_VALIDACAO = "getCNPJValidacao";
export const GET_CPF_CAPTCHA = "getCPFCaptcha";
export const GET_CPF_VALIDACAO = "getCPFValidacao";

// mutation types
export const SET_EMITENTES = "setEmitentes";

const state = {
    emitentes: []
};

const getters = {
    emitentes(state) {
        return state.emitentes;
    }
};

const actions = {
    [GET_EMITENTES_LISTA](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentesLista/" + dados.pagina + "/" + dados.quantidade, {
                    buscar: dados.buscar,
                    sortBy: dados.sortBy,
                    sortDesc: dados.sortDesc
                }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },

    [GET_EMITENTES](context, filtros) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentes", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_EMITENTE](context, idEmitente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("emitente/" + idEmitente).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [UPDATE_EMITENTE](context, emitente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitente", emitente).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_CATEGORIAS_EMITENTE_LISTA](context, filtros) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("categoriasEmitenteBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_CEP](context, cep) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("consultaCep/" + cep).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_CIDADES](context, uf) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("consultaCidades/" + uf).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_CNPJ_CAPTCHA]() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("cnpjCaptcha").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_CNPJ_VALIDACAO](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("cnpjValidacao/" + dados.cnpj + "/" + dados.captcha + "/" + dados.session).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_CPF_CAPTCHA]() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("cpfCaptcha").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_CPF_VALIDACAO](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("cpfValidacao/" + dados.cpf + "/" + dados.dataNascimento + "/" + dados.captcha + "/" + dados.session).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

const mutations = {
    [SET_EMITENTES](state, emitentes) {
        state.emitentes = emitentes;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};